/* LQK Daily Ramadan Checklist Bingo.
 * Nine good deeds on a 3x3 board — tap what you've done today, three in a
 * row is a bingo. Progress is saved per day, so the card resets each morning.
 * Depends on lqk-games-kit.js (window.LQKG).
 */
(function () {
  'use strict';
  var root = document.querySelector('[data-lqkg-bingo]');
  if (!root || !window.LQKG) return;
  var K = window.LQKG;

  var TASKS = JSON.parse(root.getAttribute('data-tasks'));
  var WINS = [[0, 1, 2], [3, 4, 5], [6, 7, 8], [0, 3, 6], [1, 4, 7], [2, 5, 8], [0, 4, 8], [2, 4, 6]];

  var gridEl = root.querySelector('[data-grid]');
  var doneEl = root.querySelector('[data-done]');
  var bingoEl = root.querySelector('[data-bingos]');
  var newBtn = root.querySelector('[data-new]');
  K.soundButton(root.querySelector('[data-sound]'));
  var win = K.modal(root);

  var KEY = 'lqkg-bingo';
  function today() { return new Date().toISOString().slice(0, 10); }
  function load() {
    try {
      var s = JSON.parse(localStorage.getItem(KEY));
      if (s && s.date === today() && Array.isArray(s.order) && s.order.length === 9) return s;
    } catch (e) {}
    return null;
  }
  function save() {
    try { localStorage.setItem(KEY, JSON.stringify(state)); } catch (e) {}
  }

  var state = load() || fresh();
  function fresh() {
    return {
      date: today(),
      order: K.shuffle(TASKS.map(function (_, i) { return i; })),
      done: [],
      celebrated: [],
    };
  }

  function bingoCount() {
    return WINS.filter(function (line) {
      return line.every(function (pos) { return state.done.indexOf(pos) > -1; });
    }).length;
  }

  function render() {
    gridEl.innerHTML = '';
    state.order.forEach(function (taskIx, pos) {
      var t = TASKS[taskIx];
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'lqkg-rb__cell' + (state.done.indexOf(pos) > -1 ? ' is-done' : '');
      b.setAttribute('data-pos', pos);
      b.setAttribute('aria-pressed', state.done.indexOf(pos) > -1 ? 'true' : 'false');
      b.innerHTML =
        '<span class="lqkg-rb__img"><img src="' + K.asset(t.img) + '" alt="" loading="lazy"></span>' +
        '<span class="lqkg-rb__label">' + t.label + '</span>' +
        '<span class="lqkg-rb__stamp" aria-hidden="true">' + K.icon('star') + '</span>';
      gridEl.appendChild(b);
    });
    hud();
  }
  function hud() {
    doneEl.textContent = state.done.length + '/9';
    bingoEl.textContent = String(bingoCount());
  }

  gridEl.addEventListener('click', function (e) {
    var b = e.target.closest('.lqkg-rb__cell');
    if (!b) return;
    var pos = +b.getAttribute('data-pos');
    var ix = state.done.indexOf(pos);
    if (ix > -1) {
      state.done.splice(ix, 1);
      b.classList.remove('is-done');
      b.setAttribute('aria-pressed', 'false');
      K.sound.tap();
    } else {
      state.done.push(pos);
      b.classList.add('is-done');
      b.setAttribute('aria-pressed', 'true');
      K.sound.ding(); K.vibrate(30);
    }
    var lines = bingoCount();
    hud(); save();
    // celebrate each NEW bingo line once
    var newLines = WINS.filter(function (line, i) {
      return line.every(function (p) { return state.done.indexOf(p) > -1; }) && state.celebrated.indexOf(i) === -1;
    });
    if (newLines.length) {
      WINS.forEach(function (line, i) {
        if (line.every(function (p) { return state.done.indexOf(p) > -1; }) && state.celebrated.indexOf(i) === -1) state.celebrated.push(i);
      });
      save();
      K.confetti(); K.sound.win();
      if (state.done.length === 9) {
        win.show({ title: 'Superstar!', stars: 3, text: 'Every good deed done today — may Allah reward you!', againLabel: 'Alhamdulillah' });
      } else {
        win.show({ title: 'BINGO!', stars: Math.min(3, lines), text: 'Three good deeds in a row — keep going, ' + (9 - state.done.length) + ' to go!', againLabel: 'Keep going' });
      }
    } else if (state.done.length === 9) {
      K.confetti(); K.sound.win();
      win.show({ title: 'Superstar!', stars: 3, text: 'Every good deed done today — may Allah reward you!', againLabel: 'Alhamdulillah' });
    }
  });

  newBtn.addEventListener('click', function () {
    state = fresh();
    save();
    render();
    K.sound.tap();
  });

  render();
})();
